import { scrubPii } from './scrubPii.js';
import { createExceptionCeiling } from './exceptionCeiling.js';

/**
 * Builds the `before_send` hook for the shared PostHog instance (plan §3.7).
 *
 * `before_send` fires on every event on the shared instance, including the
 * two tools' product-analytics captures — so it must gate on
 * `event.event === '$exception'` and pass everything else through
 * untouched. Only `$exception` events are scrubbed (§5) and counted against
 * the per-page-load ceiling (exceptionCeiling.js).
 *
 * @param {object} [options]
 * @param {number} [options.ceilingLimit] Forwarded to createExceptionCeiling.
 * @returns {(event: object) => (object|null|undefined)} The `before_send` hook.
 */
export function createPosthogBeforeSend({ ceilingLimit } = {}) {
    const applyCeiling = createExceptionCeiling(ceilingLimit);

    return function beforeSend(event) {
        if (!event || event.event !== '$exception') return event;
        return applyCeiling(scrubPii(event));
    };
}
